<div class="card-body">
    <div id="apex-stacked-area-chart"></div>
</div>